import { Button, Flex } from "@qws-org/ui-kit";
import type { FC } from "react";
// в будущем данные будут приходить из cms
// eslint-disable-next-line boundaries/external
import { useTranslation } from "react-i18next";

import { HEADER_STATIC_TRANSLATIONS } from "~/features/header/translations";

type Props = {
  playNowLink?: string;
  burgerButton?: boolean;
  featureFlags?: {
    isCreateButtonEnabled: boolean;
  };
  loginHeader: () => void;
  createAccountHeader: () => void;
};

export const HeaderAuthButtons: FC<Props> = ({
  playNowLink,
  burgerButton,
  featureFlags,
  loginHeader,
  createAccountHeader,
}) => {
  const {
    i18n: { language },
  } = useTranslation();

  const redirectToRoom = (): void => {
    if (playNowLink) {
      window.location.href = playNowLink;
    }
  };

  if (burgerButton && featureFlags?.isCreateButtonEnabled) {
    return (
      <Button
        className="w-full h-12"
        onPress={() => {
          loginHeader();
          redirectToRoom();
        }}
        variant="transparent"
      >
        {HEADER_STATIC_TRANSLATIONS[language]["auth.button.login"]}
      </Button>
    );
  }

  return (
    <Flex align="center" gap={10}>
      <Button
        p={{ px: 12 }}
        md={{ p: { px: 24 } }}
        className="hidden md:flex h-8 md:h-12 text-xs md:text-base "
        variant="transparent"
        onPress={() => {
          loginHeader();
          redirectToRoom();
        }}
        data-testid="header-login-button"
      >
        {HEADER_STATIC_TRANSLATIONS[language]["auth.button.login"]}
      </Button>

      {featureFlags?.isCreateButtonEnabled && (
        <Button
          p={{ px: 12 }}
          md={{ p: { px: 24 } }}
          className="h-8 flex items-center md:h-12 text-xs md:text-base "
          onPress={() => {
            createAccountHeader();
            redirectToRoom();
          }}
          data-testid="header-register-button"
        >
          {HEADER_STATIC_TRANSLATIONS[language]["auth.button.create"]}
        </Button>
      )}
    </Flex>
  );
};
